import { NETWORK_TO_DNO_FRIENDLY_ABBREVIATION_DISPATCHER } from "../../../../constants/dnos"
import { NA } from "../../../../constants/generalConstants"
import { invalidApiDataError } from "../../../../errors/recognisedErrors"
import {
    formatDate,
    getValue,
    tsIoValidate,
} from "../../../../utils/general/generalUtils"
import {
    IApplication,
    IApplicationListResponse,
    IRawSearchResult,
    ISummaryFacts,
    RawSearchResult,
} from "../../types/installerInterface/installerApplicationTypes"

export const installerSingleApplicationsMapper = {
    /**
     * Maps the response from the installer single applications API to the IInstallerSingleApplications interface.
     * @param response - The response from the API.
     * @returns The mapped object of type IInstallerSingleApplications.
     */
    mapSingle: (response: unknown): IApplication => {
        const res = tsIoValidate<IRawSearchResult>(
            RawSearchResult,
            response,
            "Error mapping installer single applications"
        )
        if (res.Items.length === 0) {
            throw invalidApiDataError("No installer applications found.")
        }

        let application = { ...res.Items[0] }

        if (
            application.newPremisesGenerationCapacityKw
                .newPremisesGenerationCapacityKw === null ||
            undefined
        ) {
            application = {
                ...application,
                newPremisesGenerationCapacityKw: {
                    ...application.newPremisesGenerationCapacityKw,
                    newPremisesGenerationCapacityKw: NA,
                },
            }
        }

        if (
            application.newPremisesMaxDemand.newPremisesMaxDemand === null ||
            undefined
        ) {
            application = {
                ...application,
                newPremisesMaxDemand: {
                    ...application.newPremisesMaxDemand,
                    newPremisesMaxDemand: NA,
                },
            }
        }

        const {
            installerCustomerDetails: {
                installationPostCode,
                customerEmail,
                customerName,
                installerName,
            },
            dno,
            createdDate,
        } = application

        const dnoDisplayName: string =
            getValue(
                NETWORK_TO_DNO_FRIENDLY_ABBREVIATION_DISPATCHER,
                dno as string
            ) ?? dno
        const summaryFacts: ISummaryFacts = {
            "Created Date": formatDate(createdDate),
            "Installation Post Code": installationPostCode ?? "",
            "Customer Name": customerName ?? "",
            "Customer Email": customerEmail ?? "",
            DNO: dnoDisplayName,
            "Raised By": installerName ?? "",
        }

        return {
            ...application,
            dno: dnoDisplayName,
            summaryFacts,
        }
    },

    /**
     * Maps `getInstallerApplications` response confirming valid data.
     * @param response - The response from the API.
     * @returns The mapped object of type IApplications.
     *
     * */
    mapList: (response: unknown): IApplicationListResponse => {
        const res = tsIoValidate<IRawSearchResult>(
            RawSearchResult,
            response,
            "Error mapping installer list application"
        )

        return {
            totalResults: res.Count,
            pageSizes: res.ScannedCount,
            data: res.Items,
            nextPageKey: res.LastEvaluatedKey,
        }
    },
}
